module.exports = __webpack_public_path__ + "img/paystack.231713ac.svg";